import { MyAccountPageContentView } from "./MyAccountPageContentView"

export const MyAccountPageView = () => {
    return (
        <>
        <MyAccountPageContentView/>
        </>
    )
}